var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.videoWatched)?_c('div',[_vm._m(0),_c('video-player',{attrs:{"item":_vm.videoItem,"active":true,"options":_vm.clientPlayerOptions},on:{"currentTime":_vm.updateWatchedTime,"ended":_vm.setWatched}})],1):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mb-2"},[_c('strong',[_vm._v("Watch the video then answer the questions")])])
}]

export { render, staticRenderFns }